import { IAdminFlight } from '../../../../../../../store/admin/eventFlights/store';

export const parseAge = (flight: IAdminFlight) => {
  const { ageLower, ageUpper } = flight;

  if (ageLower !== null && ageLower !== undefined && ageUpper !== null && ageUpper !== undefined) {
    return ageLower + ' to ' + ageUpper;
  } else if (ageLower !== null && ageLower !== undefined) {
    return 'Greater than ' + ageLower;
  } else if (ageUpper !== null && ageUpper !== undefined) {
    return 'Less than ' + ageUpper;
  } else {
    return '--';
  }
};
